// extracted by mini-css-extract-plugin
export default {"morse-container":"App_morse-container__HuQkl","morse-ticker":"App_morse-ticker__vm3Qc","ticker":"App_ticker__rB+PH","dot":"App_dot__IEp-p","dash":"App_dash__7ERcn"};